export class ProductCode {
  public static FreeKid = ['CHILDFREE22', 'CHILDFREE'];
  public static PaidKid = ['CHILDPAID22', 'CHILDPAID'];
  public static Guardian = ['GUARDIAN22', 'GUARDIAN'];
}
